export default __webpack_public_path__ + "static/media/close.15abc3c8.svg";